import React, { useState } from "react";
import { Dropdown, Badge } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import CheckOutModal from "../Reservation/CheckOutModal";
import CheckInModal from "../Reservation/CheckInModal";

export default function RoomActionMenu({
  date,
  room,
  userData,
  API_BASE,
  refreshRooms,
  reservation
}) {
 const [showCheckIn, setShowCheckIn] = useState(false);

  const navigate = useNavigate();
  const [showCheckout, setShowCheckout] = useState(false);
const [selectedReservation, setSelectedReservation] = useState(null);
  /* ---------------- BOH FUNCTIONS ---------------- */

  const updateHousekeeping = async (status) => {
    try {
      await axios.put(
        `${API_BASE}rooms/${room._id}/housekeeping`,
        { housekeeping: status },
        {
          params: { branch: userData.branch },
          headers: { Authorization: `Bearer ${userData.token}` }
        }
      );
      refreshRooms();
    } catch (err) {
      console.error("Housekeeping Error:", err);
    }
  };

  const updateMaintenance = async (isActive) => {
    try {
      await axios.put(
        `${API_BASE}rooms/${room._id}/maintenance`,
        {
          isActive,
          reason: isActive ? "Manual Block" : null,
          from: isActive ? new Date() : null,
          to: null
        },
        {
          params: { branch: userData.branch },
          headers: { Authorization: `Bearer ${userData.token}` }
        }
      );
      refreshRooms();
    } catch (err) {
      console.error("Maintenance Error:", err);
    }
  };

  const deactivateRoom = async () => {
    try {
      await axios.delete(
        `${API_BASE}rooms/${room._id}`,
        {
          params: { branch: userData.branch },
          headers: { Authorization: `Bearer ${userData.token}` }
        }
      );
      refreshRooms();
    } catch (err) {
      console.error("Deactivate Error:", err);
    }
  };

  const isMaintenance = room?.maintenance?.isActive;
  const housekeeping = room?.status?.housekeeping || "clean";


    const goToRefund = () => {
  navigate("/finance/refund", {
    state: { 
        // bill,
         reservation, API_BASE, token: userData.token, branch: userData.branch }
  });
};

  const goToReservationDetails = () => {
  navigate("/reservations/details", {
    state: { room, reservation, API_BASE, token: userData.token, branch: userData.branch }
  });
};
  const goToPayments = () => {
  navigate("/transactions/payment", {
    state: { room, reservation, API_BASE, token:userData.token, branch:userData.branch }
  });
};

const goToLedger = () => {
  navigate("/transactions/ledger", {
    state: { room, reservation }
  });
};

const goToSummary = () => {
  navigate("/transactions/summary", {
    state: { room, reservation, API_BASE, token: userData.token, branch: userData.branch }
  });
};

console.log(date)
  return (
    <>
    <Dropdown align="end">
      <Dropdown.Toggle variant="light" size="sm">
        ⚙ Actions
      </Dropdown.Toggle>

      <Dropdown.Menu style={{ minWidth: "260px" }}>

        {/* HEADER */}
        <Dropdown.Header>
          Room {room.roomNumber}
          <Badge bg="secondary" className="ms-2">
            {housekeeping}
          </Badge>
        </Dropdown.Header>

        {/* ---------------- FRONT OFFICE ---------------- */}

        <Dropdown.Item
          onClick={() =>
            navigate("/reservations/create", { state: {  date,room } })
          }
        >
          📝 Create Reservation
        </Dropdown.Item>
         <Dropdown.Item
          onClick={() =>
            navigate("/reservations/create", { state: { date, room } })
          }
        >
           Create Reservation
        </Dropdown.Item>

        <Dropdown.Item
          onClick={() =>{
              if(reservation && reservation.bookingStatus !== "checked-in"){
                setShowCheckIn(true);
                setSelectedReservation(reservation);
                return;
              }
            navigate("/reservations/create", { state: { date, room, bookingStatus:"checked-in" } })
          }}
        >
          🟢 Check-In
        </Dropdown.Item>
     <Dropdown.Item
  onClick={() => {
    setSelectedReservation(reservation);
    setShowCheckout(true);
  }}
>
  🔴 Check-Out
</Dropdown.Item>

        <Dropdown.Item
          onClick={() =>
            navigate("/reservations", {
              state: { room: room, reservation: reservation }
            
            })
          }
        >
          📅 View Reservations
        </Dropdown.Item>
          <Dropdown.Item onClick={goToReservationDetails}>
  📋 Reservation Details
</Dropdown.Item>
       <Dropdown.Item
  onClick={() =>
    navigate("/finance/billing", { state: { room, reservation } })
  }
>
  🧾 View / Generate Bill
</Dropdown.Item>

<Dropdown.Item onClick={goToPayments}>
  💳 Add Payment
</Dropdown.Item>

<Dropdown.Item onClick={goToLedger}>
  📜 View Ledger
</Dropdown.Item>

<Dropdown.Item onClick={goToSummary}>
 
</Dropdown.Item>

        <Dropdown.Item
          className="text-warning"
          onClick={() =>
            navigate("/reservations", {
              state: { roomNumber: room.roomNumber, action: "cancel" }
            })
          }
        >
          ❌ Cancel Reservation
        </Dropdown.Item>

        <Dropdown.Divider />

        {/* ---------------- BOH ---------------- */}

        <Dropdown.Item onClick={() => updateHousekeeping("dirty")}>
          🧹 Mark Dirty
        </Dropdown.Item>

        <Dropdown.Item onClick={() => updateHousekeeping("clean")}>
          ✨ Mark Clean
        </Dropdown.Item>

        {!isMaintenance ? (
          <Dropdown.Item onClick={() => updateMaintenance(true)}>
            🛠 Start Maintenance
          </Dropdown.Item>
        ) : (
          <Dropdown.Item onClick={() => updateMaintenance(false)}>
            ✅ End Maintenance
          </Dropdown.Item>
        )}

        <Dropdown.Divider />

        {/* ---------------- COMPLIANCE ---------------- */}

        <Dropdown.Item
          onClick={() =>
            navigate("/police-verification", { state: { room } })
          }
        >
          🚔 Police Verification
        </Dropdown.Item>

        <Dropdown.Item
          onClick={() =>
            navigate("/foreigners-entry", { state: { room } })
          }
        >
          🌍 Foreigners Address Entry
        </Dropdown.Item>

        <Dropdown.Divider />

        {/* ---------------- ADMIN ---------------- */}

        <Dropdown.Item
          className="text-danger"
          onClick={deactivateRoom}
        >
          ❌ Deactivate Room
        </Dropdown.Item>

      </Dropdown.Menu>
    </Dropdown>
    <CheckOutModal
  show={showCheckout}
  onHide={() => setShowCheckout(false)}
  selected={selectedReservation}
  refresh={refreshRooms}
  userData={userData}
  API_BASE={API_BASE}
/>
<CheckInModal   
show={showCheckIn} 
onHide={() => setShowCheckIn(false)}
 selected={selectedReservation} 
 refresh={refreshRooms} 
  API_BASE={API_BASE}
  token={userData.token}
  branch={userData.branch}
/>
    </>
  );
}